import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import useTranslate from 'Pods/SearchPage/Shared/useTranslate'

const NEW_PROJECT_PATH = '/3d-modeling-jobs/new'

function FreelancerCard() {
  const translate = useTranslate()

  return (
    <div className="promo-card">
      <div className="promo-card__text">
        <h3 className="promo-card__title cgt-heading-400">
          {translate('search_page.promo_cards.freelancer.title')}
        </h3>
        <p className="promo-card__description cgt-body-lg">
          {translate('search_page.promo_cards.freelancer.description')}
        </p>
      </div>
      <div className="promo-card__actions">
        <Button
          href={NEW_PROJECT_PATH}
          type="primary"
          size="medium"
          customClass="promo-card__button"
        >
          {translate('search_page.promo_cards.freelancer.cta')}
        </Button>
      </div>
    </div>
  )
}

export default FreelancerCard
